import React from 'react';
import './Logo.css';

const Logo = () => {
  return (
    <div className="logo-container">
      <img 
        src="https://hub.afracell.com/assets/img/logo.png" 
        alt="افراسل" 
        className="logo-image"
        onError={(e) => {
          e.target.onerror = null;
          e.target.style.display = 'none';
          const fallback = document.createElement('span');
          fallback.className = 'logo-fallback';
          fallback.textContent = '◈';
          e.target.parentNode.appendChild(fallback);
        }}
      />
      <span className="logo-text">افراسل</span>
    </div>
  );
};

export default Logo;
